// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"93":"list","152":"wap","177":"home","640":"wap-list"}[chunkId] + "." + {"93":"fc2df62b","152":"a0b5d601","177":"efd503db","640":"28e02584"}[chunkId] + ".css";
};